import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, isDevMode } from '@angular/core';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FullComponent } from './shared/layout/full/full.component';
import { SharedModule } from './shared/shared.module';
import { AuthenticationModule } from './shared/authentication';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './shared/authentication/authenticaion.interceptor';
import { TranslocoModule, TranslocoService, provideTransloco } from '@jsverse/transloco';
import { TranslocoHttpLoader } from './shared/config/transloco-http-loader';
import { NGRXStoreModule } from './shared/store/store.module';


@NgModule({
  declarations: [
    AppComponent,
    FullComponent,



  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    AuthenticationModule,
    NGRXStoreModule


  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    provideTransloco({
      config: {
          availableLangs: [
            {id: 'en', label: "English", rtl: false} as {id: string, label: string},
            {id: 'ar', label: "Arabic", rtl: true} as {id: string, label: string},
          ],
          defaultLang: 'en',
          // Remove this option if your application doesn't support changing language in runtime.
          reRenderOnLangChange: true,
          failedRetries: 5,
          prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader
  }),
    TranslocoService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
